"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormBuilderStep = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_hook_form_1 = require("react-hook-form");
const form_builder_style_1 = require("../form-builder.style");
const hooks_1 = require("../hooks");
const use_synchronize_store_1 = require("../hooks/use-synchronize-store");
const utils_1 = require("../utils");
const back_button_1 = require("./back-button");
const form_builder_footer_1 = require("./form-builder-footer");
const form_builder_step_item_1 = require("./form-builder-step-item");
const form_builder_submit_1 = require("./form-builder-submit");
exports.FormBuilderStep = (0, react_1.memo)(({ components, defaultValues, params, isBannerVisible, isBackButtonVisible, isSubmitVisible, isFooterVisible, isStickyFooter, handleOnClickBack, contentWidth, debugMode, }) => {
    const { currentStep, activeStep, wantNextStep, setWantNextStep, setCurrentStep, isResetFormState, setDisabledSubmit, setIsResetFormState, otpStep, isSmartComponentsShowing, setFormState, productFormState, setDisableForm, handleAuth, setFormBuilderIsMounted, setAuthError, startEventHandler, signupStartEventHandler, registrationStartEventHandler, useOtp, otpAffectsSubmit, } = params;
    const { control, reset, setValue, getValues, setError, clearErrors, handleSubmit, formState: { isDirty, isSubmitting, isSubmitSuccessful, errors, submitCount, }, } = (0, react_hook_form_1.useForm)({ values: defaultValues });
    const elementRefs = (0, hooks_1.useScrollToElementWithError)(submitCount, errors);
    const formBuilderStepWrapperRef = (0, react_1.useRef)(null);
    const isShowOtp = useOtp && currentStep === otpStep;
    (0, use_synchronize_store_1.useSynchronizeStore)(control, setFormState, clearErrors, setAuthError, debugMode);
    (0, react_1.useEffect)(() => {
        if (isDirty && startEventHandler) {
            startEventHandler();
        }
    }, [isDirty]);
    (0, react_1.useEffect)(() => {
        if (isResetFormState) {
            reset(productFormState);
            setIsResetFormState === null || setIsResetFormState === void 0 ? void 0 : setIsResetFormState(false);
        }
    }, [isResetFormState]);
    (0, react_1.useEffect)(() => {
        setCurrentStep(activeStep);
    }, [activeStep]);
    (0, react_1.useEffect)(() => {
        setFormBuilderIsMounted();
    }, []);
    const updateFormHandlerObject = (0, react_1.useCallback)(({ fieldName, value }) => {
        updateFormHandler(fieldName, value);
    }, []);
    const updateFormHandler = (0, react_1.useCallback)((fieldName, value) => {
        getValues();
        setValue(fieldName, value);
    }, []);
    const updateFormErrorHandler = (0, react_1.useCallback)(({ fieldName, err }) => {
        setError(fieldName, { message: err });
        setDisableForm(false);
    }, []);
    const handleAuthUser = (0, react_1.useCallback)(({ phone }) => {
        if (currentStep === otpStep) {
            const client = getValues('WhoIssuesPolicy.client');
            if (client && signupStartEventHandler) {
                signupStartEventHandler();
            }
            else if (registrationStartEventHandler) {
                registrationStartEventHandler();
            }
        }
        handleAuth(phone);
    }, [handleAuth, currentStep]);
    (0, react_1.useEffect)(() => {
        const unsubscribe = utils_1.FormBuilderEventBus.subscribe(utils_1.FormBuilderAction.SUBMIT_FORM, handleSubmit(() => { }));
        return unsubscribe;
    }, [handleSubmit]);
    (0, react_1.useEffect)(() => {
        const unsubscribe = utils_1.FormBuilderEventBus.subscribe(utils_1.FormBuilderAction.UPDATE_FORM, updateFormHandlerObject);
        return unsubscribe;
    }, [updateFormHandlerObject]);
    (0, react_1.useEffect)(() => {
        const unsubscribe = utils_1.FormBuilderEventBus.subscribe(utils_1.FormBuilderAction.UPDATE_FORM_ERRORS, updateFormErrorHandler);
        return unsubscribe;
    }, [updateFormErrorHandler]);
    (0, react_1.useEffect)(() => {
        const unsubscribe = utils_1.FormBuilderEventBus.subscribe(utils_1.FormBuilderAction.AUTH_USER, handleAuthUser);
        return unsubscribe;
    }, [handleAuthUser]);
    const disabledSubmit = (0, hooks_1.useDisabledSubmit)({
        errors,
        submitCount,
        wantNextStep,
        isShowOtp,
        otpAffectsSubmit,
    });
    (0, react_1.useEffect)(() => {
        setDisabledSubmit(disabledSubmit);
    }, [disabledSubmit]);
    (0, react_1.useEffect)(() => {
        if (isSubmitSuccessful && !isSubmitting) {
            setWantNextStep(true);
        }
    }, [isSubmitSuccessful, isSubmitting]);
    const setRefHandler = (0, react_1.useCallback)((e, name) => (elementRefs.current[name] = e), []);
    return ((0, jsx_runtime_1.jsxs)(form_builder_style_1.FormBuilderStepWrapper, { ref: formBuilderStepWrapperRef, children: [(0, jsx_runtime_1.jsxs)(form_builder_style_1.FormBuilderStepContent, { contentWidth: contentWidth, children: [isBackButtonVisible && ((0, jsx_runtime_1.jsx)(back_button_1.BackButton, { handleOnClickBack: handleOnClickBack })), (0, jsx_runtime_1.jsx)(form_builder_style_1.FormBuilderStepItems, { isBackButtonVisible: !!isBackButtonVisible, children: components.body
                            .filter((item) => (item === null || item === void 0 ? void 0 : item.step) === activeStep)
                            .map((component) => ((0, jsx_runtime_1.jsx)(form_builder_step_item_1.FormBuilderStepItem, { setRef: setRefHandler, activeStep: activeStep, component: component, isSubmitting: isSubmitting, control: control, isSmartComponentsShowing: isSmartComponentsShowing, debugMode: debugMode }, `${activeStep}${component.props.id}`))) }), isSubmitVisible && ((0, jsx_runtime_1.jsx)(form_builder_submit_1.FormBuilderSubmit, { components: components.submit })), isFooterVisible && ((0, jsx_runtime_1.jsx)(form_builder_footer_1.FormBuilderFooter, { isStickyFooter: isStickyFooter, components: components.footer, contentRef: formBuilderStepWrapperRef }))] }), isBannerVisible && ((0, jsx_runtime_1.jsx)(form_builder_style_1.BannerWrapper, { children: components.banner
                    .filter((item) => item.step === -1 || item.step === activeStep)
                    .map((component) => ((0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)(form_builder_step_item_1.FormBuilderStepItem, { setRef: setRefHandler, activeStep: activeStep, component: component, isSubmitting: isSubmitting, control: control, isSmartComponentsShowing: isSmartComponentsShowing }, `${activeStep}${component.props.id}`) }))) }))] }));
});
exports.FormBuilderStep.displayName = 'FormBuilderStep';
